import _ from "lodash";

import { api, fetchRespJson } from "apis/base";

export default {
  getSegmentExperiments,
};

async function getSegmentExperiments({ segmentId, startDate }) {
  let apiUrl = `${api}/segment/${segmentId}/experiments?startDate=${startDate}`;
  const { experiments } = await fetchRespJson(apiUrl);
  return experiments;
}
